<!-- <div
  class="app__sidebar--components--wrapper w-[100%]"
  [ngClass]="{
    'h-[60px]': !brokenLinkSectionExpanded,
    'h-fit': brokenLinkSectionExpanded
  }"
  style="margin-bottom: 12px; width: calc(100% - 24px) !important"
>
  <div
    class="flex items-center justify-between w-full text-k-blue bg-[#fdfdfd] px-4 rounded-[inherit] hover:cursor-pointer"
    [ngClass]="{
      'h-full border-none ': !brokenLinkSectionExpanded,
      'h-[54px] rounded-b-none ': brokenLinkSectionExpanded,
      'explore-ai-btn--hover': isHovering,
      'explore-ai-btn--normal': !isHovering
    }"
    style="box-shadow: 0px 4px 34px 0px rgba(0, 0, 0, 0.06)"
  >
    <span class="flex items-center gap-2 m-0" style="width: -webkit-fill-available" role="button">
      <button
        style="background: transparent; justify-content: start !important; width: -webkit-fill-available !important"
        class="explore-ai-btn h-10 cursor-pointer font-semibold text-[16px] flex items-center justify-center gap-2 transition-all duration-200"
        (click)="$event.stopPropagation(); handleMxDrawer()"
      >
        <img src="assets/images/Ai-icon.svg" class="w-4 h-4 ai-icon" />
        <span>Explore with Ai </span>
      </button>
    </span>

    <span class="text-[#25508e] font-bold text-2xl text-center">
      <mat-icon [ngClass]="{ 'rotate-[270deg]': !brokenLinkSectionExpanded }">keyboard_arrow_down</mat-icon>
    </span>
  </div>
  @if(brokenLinkSectionExpanded){
  <div class="app__sidebar--components--scrollItems">
    @if(summaryData){
    <div class="relative m-4 flex border border-[#d3dce8] rounded-lg bg-[#F9FAFC] max-h-[350px] p-4 border-dashed">
      <div [innerHTML]="summaryData" style="white-space: pre-line; overflow: auto"></div>
    </div>
    }
  </div>
  }
</div> -->
@if(isComplexTemplateAi){
<div class="border bg-white rounded-lg border-[#d3dce8] p-4">
  <div class="h-10 flex">
    <button
      class="h-10 w-[50%] cursor-pointer font-semibold text-[16px] border border-[#5475C0]"
      style="border-radius: 4px 0px 0px 4px"
      [ngClass]="enableTab == 'Summary' ? 'bg-[#5475C0] text-white' : 'text-[#5475C0] bg-transparent hover:bg-[#EBF0FA]'"
      (click)="enableTab = 'Summary'"
    >
      Summary
    </button>

    <button
      class="complex-template-ai-explore-ai-btn h-10 w-[50%] cursor-pointer font-semibold text-[16px] flex items-center justify-center gap-2 transition-all duration-200"
      [ngClass]="{
        'complex-template-ai-explore-ai-btn--active': enableTab == 'Explore with Ai',
        'complex-template-ai-explore-ai-btn--hover': isHovering && enableTab != 'Explore with Ai',
        'complex-template-ai-explore-ai-btn--normal': !isHovering && enableTab != 'Explore with Ai'
      }"
      (mouseenter)="isHovering = true"
      (mouseleave)="isHovering = false"
      (click)="enableTab = 'Explore with Ai'"
    >
      <img src="assets/images/Ai-icon.svg" class="w-4 h-4 ai-icon" />
      <span>Explore</span>
    </button>
  </div>
  <div class="w-full">
    @if(enableTab == 'Summary'){
    <div class="mt-4 h-[426px] flex border border-[#DADADA] rounded-lg bg-[#F9FAFC] pr-[10px] pl-4 py-5 w-full">
      <div class="w-full">
        <!-- @if( ai_is_running ){ @for (item of [1,2,3]; track item) {
        <div>
          <div class="flex loader-body w-full">
            <div class="ph-item loader-body-item w-full pt-[26px]">
              <div class="ph-col-12 p-0">
                <div class="ph-row">
                  <div class="ph-col-12"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        } }@else{ -->
      @if(summaryData){
        <div class="max-h-[384px] overflow-y-auto w-full updateScroll pr-[6px]">
          <div class="flex items-center justify-between pr-[8px] mb-[12px]" style="position: sticky; background: #f9fafc; top: 0px">
            <div class="text-[#18191C] font-bold text-base font-open-sans">Here's a summary of {{ documentName }}</div>
            <button class="update-summary-btn px-3 py-1 flex items-center gap-1" (click)="updateSummaryData()">
              <mat-icon class="texr-[#FFFFFF] leading-[20px] text-xl w-5 h-5">refresh</mat-icon> Update
            </button>
          </div>
          <div [innerHTML]="summaryData" class="text-[#18191C] text-sm font-open-sans" style="white-space: pre-line; overflow: auto"></div>
        </div>
        }@else{
          @if(linkDocuments && linkDocuments.length > 0){
            <div class="flex justify-end">
              <button class="update-summary-btn px-3 py-1 flex items-center gap-1" (click)="updateSummaryData()">
                <mat-icon class="texr-[#FFFFFF] leading-[20px] text-xl w-5 h-5">refresh</mat-icon> Update
              </button>
            </div>
          }

        <div class="flex flex-col items-center justify-center h-full w-full pr-[6px]">
          @if(linkDocuments && linkDocuments.length === 0){
            <div><img src="assets/images/state-zero/summery-doc.svg" class="w-10 h-10" /></div>
            <div class="text-[#18191C] font-normal text-base font-open-sans mt-[25px]">Attach Documents To Create A Summary</div>
            <div class="w-[485px] text-center text-[#707070] leading-[23.8px] text-sm font-open-sans font-medium mt-[12px] letter-spacing-[0.168px]">
              Currently, there's no summary to show. Summaries are generated once you've attached one or more documents to this template.
            </div>
          }@else{
            @if(updatingSummary){
              <div class="h-[calc(100%-42px)] w-full">
                <div class="text-[#18191c] text-sm font-open-sans font-bold mb-[12px]">Updating Summary...</div>
                <div class="w-full h-full">
                  <div class="ph-item border-none bg-transparent p-0">
                    <div class="ph-col-12">
                      <div class="ph-row">
                        <div class="ph-col-12 big h-[30px] bg-[#D9D9D9] rounded-[4px]"></div>
                      </div>
                      <div class="ph-row">
                        <div class="ph-col-6 big h-[30px] bg-[#D9D9D9] rounded-[4px]"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }@else{
              <div><img src="assets/images/state-zero/summery-doc.svg" class="w-10 h-10" /></div>
              <div class="text-[#18191C] font-normal text-base font-open-sans mt-[25px]">Ready To Generate Summary</div>
              <div class="w-[485px] text-center text-[#707070] leading-[23.8px] text-sm font-open-sans font-medium mt-[12px] letter-spacing-[0.168px]">
                Documents have been attached. Click the Update button to generate a summary for this template.
              </div>
            }
          }
        </div>
        } 
      <!-- } -->
      </div>
    </div>
    } @if(enableTab == 'Explore with Ai'){
    <div class="mt-4">
      <div class="h-[426px] overflow-auto w-full updateScroll pr-[6px]">
        @if(!summaryData){
          <div class="flex border border-[#DADADA] rounded-lg bg-[#F9FAFC] pr-[10px] pl-4 py-5 w-full h-full">
            <div class="w-full">
              @if(linkDocuments && linkDocuments.length > 0){
                <div class="flex justify-end">
                  <button class="update-summary-btn px-3 py-1 flex items-center gap-1" (click)="updateSummaryData()">
                    <mat-icon class="texr-[#FFFFFF] leading-[20px] text-xl w-5 h-5">refresh</mat-icon> Update
                  </button>
                </div>
              }
              @if(linkDocuments && linkDocuments.length === 0){
                  <div class="flex flex-col items-center justify-center h-full w-full">
                    <div><img src="assets/images/state-zero/summery-doc.svg" class="w-10 h-10" /></div>
                    <div class="text-[#18191C] font-normal text-base font-open-sans mt-[25px]">Link Documents To Explore With AI</div>
                    <div class="w-[485px] text-center text-[#707070] leading-[23.8px] text-sm font-open-sans font-medium mt-[12px] letter-spacing-[0.168px]">
                      When you link one or more documents to this template, you will be able to ask AI questions about the document(s) here.
                    </div>
                  </div>
              }@else {
                @if(updatingSummary){
                  <div class="h-[calc(100%-42px)] w-full">
                    <div class="text-[#18191c] text-sm font-open-sans font-bold mb-[12px]">Updating Summary...</div>
                    <div class="w-full h-full">
                      <div class="ph-item border-none bg-transparent p-0">
                        <div class="ph-col-12">
                          <div class="ph-row">
                            <div class="ph-col-12 big h-[30px] bg-[#D9D9D9] rounded-[4px]"></div>
                          </div>
                          <div class="ph-row">
                            <div class="ph-col-6 big h-[30px] bg-[#D9D9D9] rounded-[4px]"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }@else{
                  <div class="flex flex-col items-center justify-center h-[calc(100%-10px)] w-full">
                    <div><img src="assets/images/state-zero/summery-doc.svg" class="w-10 h-10" /></div>
                    <div class="text-[#18191C] font-normal text-base font-open-sans mt-[25px]">Ready To Generate Summary</div>
                    <div class="w-[485px] text-center text-[#707070] leading-[23.8px] text-sm font-open-sans font-medium mt-[12px] letter-spacing-[0.168px]">
                      Documents have been attached. Click the Update button to generate a summary for this template.
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        }@else {
        <explore-with-ai-chat
          [currentTemplate]="currentTemplate"
          [summaryData]="summaryData"
          [vault_user_form_id]="currentFormId"
          [isNonDocumentSummary]="true"
          [linkedForms]="linkedForms"
          [linkDocuments]="linkDocuments"
          [sessionId]="sessionId"
        ></explore-with-ai-chat>
        }
      </div>
    </div>
    }
  </div>
</div>
}@else{
<mat-accordion multi="false">
  <mat-expansion-panel [(expanded)]="expandedPanel" (expandedChange)="togglePanel()" hideToggle class="explore-ai-accordion-container">
    <mat-expansion-panel-header class="explore-ai-accordion-header">
      <div class="flex justify-between items-center w-full explore-ai-with-summary-accordion-header-content">
        <div class="flex items-center gap-2">
          <img src="assets/images/Ai-icon.svg" class="w-7 h-7" />
          <div class="explore-ai-title">Explore with Ai</div>
        </div>

        <div class="flex w-fit item-center justify-end gap-3">
          <!-- @if(!view_summary){
            <div class="new-summary-tag">
              New Summary
            </div>
            } -->
          <div class="flex items-center">
            @if(expandedPanel){
            <mat-icon class="explore-ai-accordion-icon">expand_more</mat-icon>
            }@else {
            <mat-icon class="explore-ai-accordion-icon">chevron_right</mat-icon>
            }
          </div>
        </div>
      </div>
    </mat-expansion-panel-header>

    <div class="explore-ai-card-content">
      @if(!summaryData){  
        <div class="flex border border-[#DADADA] rounded-lg bg-[#F9FAFC] pr-[10px] pl-4 py-5 w-full h-full">
          <div class="w-full">
            @if(linkDocuments && linkDocuments.length > 0){
              <div class="flex justify-end">
                <button class="update-summary-btn px-3 py-1 flex items-center gap-1" (click)="updateSummaryData()">
                  <mat-icon class="texr-[#FFFFFF] leading-[20px] text-xl w-5 h-5">refresh</mat-icon> Update
                </button>
              </div>
            }
            @if(linkDocuments && linkDocuments.length === 0){
                <div class="flex flex-col items-center justify-center h-full w-full">
                <div><img src="assets/images/state-zero/summery-doc.svg" class="w-10 h-10" /></div>
                <div class="text-[#18191C] font-normal text-base font-open-sans mt-[25px]">Link Documents To Explore With AI</div>
                <div class="w-[485px] text-center text-[#707070] leading-[23.8px] text-sm font-open-sans font-medium mt-[12px] letter-spacing-[0.168px]">
                  When you link one or more documents to this template, you will be able to ask AI questions about the document(s) here.
                </div>
              </div>
            }@else {
              @if(updatingSummary){
                <div class="h-[calc(100%-42px)] w-full">
                  <div class="text-[#18191c] text-sm font-open-sans font-bold mb-[12px]">Updating Summary...</div>
                  <div class="w-full h-full">
                    <div class="ph-item border-none bg-transparent p-0">
                      <div class="ph-col-12">
                        <div class="ph-row">
                          <div class="ph-col-12 big h-[30px] bg-[#D9D9D9] rounded-[4px]"></div>
                        </div>
                        <div class="ph-row">
                          <div class="ph-col-6 big h-[30px] bg-[#D9D9D9] rounded-[4px]"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }@else{
                <div class="flex flex-col items-center justify-center h-[calc(100%-10px)] w-full">
                <div><img src="assets/images/state-zero/summery-doc.svg" class="w-10 h-10" /></div>
                <div class="text-[#18191C] font-normal text-base font-open-sans mt-[25px]">Ready To Generate Summary</div>
                <div class="w-[485px] text-center text-[#707070] leading-[23.8px] text-sm font-open-sans font-medium mt-[12px] letter-spacing-[0.168px]">
                  Documents have been attached. Click the Update button to generate a summary for this template.
                </div>
              </div>
              }
            }
          </div>
        </div>
      }@else {
      <explore-with-ai-chat
        [isNonDocumentSummary]="true"
        [currentTemplate]="currentTemplate"
        [summaryData]="summaryData"
        [vault_user_form_id]="currentFormId"
      ></explore-with-ai-chat>
      }
    </div>
  </mat-expansion-panel>
</mat-accordion>
}
